export const BURGER_OPEN = 'BURGER_OPEN'
export const BURGER_CLOSE = 'BURGER_CLOSE'
export const IMAGE_CLOSE = 'IMAGE_CLOSE'
export const IMAGE_OPEN = 'IMAGE_OPEN'
